var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 448.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.8,18.8c-20.9-8.5-43-12.8-65.7-12.8-22.7,0-44.8,4.3-65.7,12.8-21.7,8.8-41.1,21.7-57.8,38.4-16.7,16.7-29.6,36.1-38.4,57.8-8.5,20.9-12.8,43-12.8,65.7,0,22.7,4.3,44.8,12.8,65.7,8.8,21.7,21.7,41.1,38.4,57.8,16.7,16.7,36.1,29.6,57.8,38.4,20.9,8.5,43,12.8,65.7,12.8,22.7,0,44.8-4.3,65.7-12.8,16.4-6.7,31.5-15.7,45.2-26.9l125.4,125.4c6.7,6.7,17.4,6.7,24.1,0h0c6.7-6.7,6.7-17.4,0-24.1l-125.4-125.4c11.2-13.6,20.2-28.7,26.9-45.2,8.5-20.9,12.8-43,12.8-65.7,0-22.7-4.3-44.8-12.8-65.7-8.8-21.7-21.7-41.1-38.4-57.8-16.7-16.7-36.1-29.6-57.8-38.4ZM310.4,127.8c6.8,16.8,10.3,34.6,10.3,52.9,0,18.3-3.5,36.1-10.3,52.9-7.1,17.4-17.5,33.1-30.9,46.5-13.4,13.4-29.1,23.8-46.5,30.9-16.8,6.8-34.6,10.3-52.9,10.3-18.3,0-36.1-3.5-52.9-10.3-17.4-7.1-33.1-17.5-46.5-30.9-13.4-13.4-23.8-29.1-30.9-46.5-6.8-16.8-10.3-34.6-10.3-52.9,0-18.3,3.5-36.1,10.3-52.9,7.1-17.4,17.5-33.1,30.9-46.5,13.4-13.4,29.1-23.8,46.5-30.9,16.8-6.8,34.6-10.3,52.9-10.3,18.3,0,36.1,3.5,52.9,10.3,17.4,7.1,33.1,17.5,46.5,30.9,13.4,13.4,23.8,29.1,30.9,46.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 85.9,
    y: 166.6,
    width: 188.4,
    height: 28.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoomOut.8dcd757853998277f7b01fbdd113f33d.svg";
export { ForwardRef as ReactComponent };